const emailData = [

    {
        id: 9,
        text: 'secondary',
        status: 'AF',
        title: 'Empresa Testes 007',
        canais: ['whatsapp','email'],
        subject: 'Mensagem prospecção enviada @comercialEmpresa',
        date: '01-Junho',
        repres: 'Representante 001'
    },
    {
        id: 8,
        text: 'success',
        status: 'PR',
        canais: ['instagram'],
        title: 'Empresa Testes 006',
        subject: 'Mensagem prospecção enviada @comercialEmpresa',
        date: '01-Junho',
        repres: 'Representante 001'
    },
    {
        id: 7,
        text: 'success',
        status: 'NG',
        canais: ['instagram'],
        title: 'Empresa Testes 008',
        subject: 'Mensagem prospecção enviada @comercialEmpresa',
        date: '01-Junho',
        repres: 'Representante 001'
    },
    {
        id: 6,
        leitura: true,
        text: 'secondary',
        status: 'CR',
        canais: ['linkedin'],
        title: 'Empresa Testes 005',
        subject: 'Mensagem prospecção enviada @comercialEmpresa',
        date: '01-Junho',
        repres: 'Representante 001'
    },
    {
        id: 5,
        text: 'secondary',
        canais: ['facebook'],
        status: 'DS',
        title: 'Empresa Testes 004',
        subject: 'E-mail prospecção enviado comercial@empresa',
        date: '01-Junho',
        repres: 'Representante 001'
    },
    {
        id: 4,
        text: 'success',
        canais: ['email'],
        status: 'AF',
        title: 'Empresa Testes 009',
        subject: 'E-mail agendamento apresentação enviado comercial@empresa',
        date: '01-Junho',
        repres: 'Representante 001'
    },
    {
        id: 3,
        text: 'secondary',
        canais: ['email'],
        status: 'AF',
        title: 'Empresa Testes 003',
        subject: 'Mensagem de negociação enviada 27.9-9999-0000',
        date: '01-Junho',
        repres: 'Representante 001'
    },

    {
        id: 2,
        text: 'secondary',
        canais: ['linkedin'],
        status: 'AF',
        title: 'Empresa Testes 002',
        subject: 'E-mail boas vindas enviado comercial@empresa',
        date: '01-Junho',
        repres: 'Representante 003'
    },
    {
        id: 1,
        leitura: true,
        text: 'success',
        canais: ['linkedin'],
        status: 'AF',
        title: 'Empresa Testes 001',
        subject: 'Mensagem boas vindas enviada @comercialEmpresa',
        date: '01-Junho',
        repres: 'Representante 002'
    },


    ];


export { emailData };

